var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(value,index){return _c('span',{key:index},[_vm._v(_vm._s(value[_vm.field])),(index < _vm.list.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }